import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 费用tab-运价表查询
export function queryQuotation(data) {
  return request({
    url: URL.price.quotation.queryQuotation,
    method: 'post',
    data
  })
}

// 报价单状态变更
export function editQuotationStatus(data) {
  return request({
    url: URL.price.quotation.editQuotationStatus,
    method: 'post',
    data
  })
}

// 加载Quotation的关联实体信息
export function loadQuotationRelated(params) {
  return request({
    url: URL.price.quotation.loadQuotationRelated,
    method: 'get',
    params
  })
}
// 报价单复制
export function copyQuotation(data) {
  return request({
    url: URL.price.quotation.copyQuotation,
    method: 'post',
    data
  })
}
// 空运运费服务项目
export function queryPriceServiceAir(data) {
  return request({
    url: URL.price.quotation.queryPriceServiceAir,
    method: 'get',
    data
  })
}

// 报价单复制
export function saveQuotation(data) {
  return request({
    url: URL.price.quotation.saveQuotation,
    method: 'post',
    data
  })
}

// 远程订舱回写报价单job号
export function setQuotationJobNo(data) {
  return request({
    url: URL.price.quotation.setQuotationJobNo,
    method: 'post',
    data
  })
}
// 加载Quotation的关联实体信息
export function deleteQuotationFunc(params) {
  return request({
    url: URL.price.quotation.deleteQuotationUrl,
    method: 'get',
    params
  })
}
